import { SaleActivityInfo } from "./types";

export type SaleActivityRole = "expert" | "user";

export interface SaleActivityAuditState {
  status?: number;
  text?: string;
  passed: boolean;
  rejected: boolean;
  pending: boolean;
}

const submitResultToExpertAuditStatus: Record<number, number> = {
  2: 1,
  3: 2,
  4: 3,
};

const submitResultToUserAuditStatus: Record<number, number> = {
  2: 0,
  3: 1,
  4: 2,
};

const canSubmitResultStatusSignUp = (status: unknown) => {
  const resultStatus = Number(status);
  return Number.isNaN(resultStatus) || resultStatus === 1 || resultStatus === 4;
};

export function canSaleActivityExpertSignUp(item: SaleActivityInfo | null | undefined) {
  if (!item) return false;
  return item.expertHire === 1 &&
    item.expertTimeStatus === 2 &&
    canSubmitResultStatusSignUp(item.expertHireResultStatus);
}

export function canSaleActivityUserSignUp(item: SaleActivityInfo | null | undefined) {
  if (!item) return false;
  return item.userHire === 1 &&
    item.userTimeStatus === 2 &&
    canSubmitResultStatusSignUp(item.userSignUpResultStatus);
}

export function isSaleActivityEnded(item: SaleActivityInfo | null | undefined) {
  if (!item) return false;
  return Number(item.activityLearnStatus) === 3 || item.activityLearnStatusText === "已结束";
}

export function getSaleActivityAuditState(item: SaleActivityInfo | null | undefined, role: SaleActivityRole): SaleActivityAuditState {
  if (!item) {
    return { passed: false, rejected: false, pending: true };
  }

  if (role === "expert") {
    const rawStatus = item.expertAuditStatus ?? item.expertHireResultStatus;
    const status = item.expertAuditStatus ?? submitResultToExpertAuditStatus[Number(item.expertHireResultStatus)];
    const text = item.expertAuditStatusText || item.expertHireResultStatusText || getExpertAuditStatusText(status ?? rawStatus);
    return {
      status,
      text,
      passed: status === 2,
      rejected: status === 3,
      pending: status === 1 || status === undefined,
    };
  }

  const rawStatus = item.userAuditStatus ?? item.userSignUpResultStatus;
  const status = item.userAuditStatus ?? submitResultToUserAuditStatus[Number(item.userSignUpResultStatus)];
  const text = item.userAuditStatusText || item.userSignUpResultStatusText || getUserAuditStatusText(status ?? rawStatus);
  return {
    status,
    text,
    passed: status === 1,
    rejected: status === 2,
    pending: status === 0 || status === undefined,
  };
}

export function getSaleActivityTimeStatusText(item: SaleActivityInfo | null | undefined, role: SaleActivityRole) {
  if (!item) return "--";
  if (role === "expert") {
    return item.expertTimeStatusText || getTimeStatusText(item.expertTimeStatus);
  }
  return item.userTimeStatusText || getTimeStatusText(item.userTimeStatus);
}

function getExpertAuditStatusText(status?: number) {
  if (status === 1) return "待审核";
  if (status === 2) return "已认证";
  if (status === 3) return "已驳回";
  return undefined;
}

function getUserAuditStatusText(status?: number) {
  if (status === 0) return "审核中";
  if (status === 1) return "审核通过";
  if (status === 2) return "审核拒绝";
  return undefined;
}

function getTimeStatusText(status?: number) {
  if (status === 0) return "";
  if (status === 1) return "待报名";
  if (status === 2) return "报名中";
  if (status === 3) return "已结束";
  return "--";
}
